import React, { Component } from 'react';
import _ from 'lib/lodash'

import ACL from 'components/common/ACL'
import fileSize from 'filesize'
import FontIcon from 'react-md/lib/FontIcons/FontIcon';
import MenuButton from 'react-md/lib/Menus/MenuButton';
import Button from 'react-md/lib/Buttons'
import ListItem from 'react-md/lib/Lists/ListItem';
import Divider from 'react-md/lib/Dividers'

import TextFieldEdit from 'components/common/TextFieldEdit'

import Skeleton from 'components/common/Skeleton'
import ImagePlaceholder from 'components/common/ImagePlaceholder'
import LoadingSpinnerSmall from 'components/common/LoadingSpinnerSmall'

import './ImageCardItem.css'

class ImageCardItem extends Component {
	constructor(props) {
		super(props);

		const { node } = props;

		this.state = {
			isLoading: true,
			isEditing: false,
			thumbnailUrl: _.get(node, 'storage.thumbnailPublicUrl'),
			error: null,
		};

		this.image = new Image();
	}

	loadThumbnail = () => {
		let { image } = this;
		const { thumbnailUrl } = this.state;

		if (thumbnailUrl) {
			image.onload = () => this.setState({
				isLoading: false,
				thumbnailUrl,
				error: null
			});

			image.onerror = () => this.setState({
				isLoading: false,
				thumbnailUrl,
				error: new Error("Bildvorschau konnte nicht geladen werden")
			});

			image.src = thumbnailUrl;

		} else {
			this.setState({
				isLoading: false,
				thumbnailUrl: null,
				error: new Error("Vorschau wird geladen...") // Keine Bildvorschau verfügbar
			});
		}
	};

	handleActionNestedItems = e => {
		this.listItem._handleClick(e);
		this.setState({
			...this.state,
		});
	};

	updateProperty = property => {
		const { node, actionHandler } = this.props;
		const { changeNodeProperty } = actionHandler;

		changeNodeProperty(node, property);
	};

	handleMenuOpen = e => {
		const { node } = this.props;
		const fileUrl = _.get(node, 'storage.fileUrl');

		if (fileUrl) window.open(fileUrl);
	};

	handleMenuEdit = () => this.setState({ ...this.state, isEditing: true });

	handleMenuEditExit = () => {
		const { actionHandler } = this.props;

		this.setState({...this.state, isEditing: false});
		actionHandler.addToast("Änderungen gespeichert");
	};

	handleMenuDelete = e => {
		const { node, actionHandler } = this.props;
		const { deleteNodeFromPayload, addToast } = actionHandler;

		deleteNodeFromPayload(node).then(() => addToast("Bild gelöscht"));
	};

	componentDidMount() {
		this.loadThumbnail();
	}

	/*shouldComponentUpdate(nextProps, nextState) {
		// re-render only if node contents has changed (WARNING!! deletion not handled yet
		if (!_.isEqual(nextProps.node, this.props.node) || nextState !== this.state) {
			console.log('rerendering')
		}
		return !_.isEqual(nextProps.node, this.props.node) || nextState !== this.state;
	}*/

	componentWillReceiveProps(nextProps) {
		const { node } = nextProps;
		const thumbnailUrl = _.get(node, 'storage.thumbnailPublicUrl');

		if (thumbnailUrl && thumbnailUrl !== this.state.thumbnailUrl) {
			this.setState({
				...this.state,
				thumbnailUrl
			}, () => this.loadThumbnail());
		}
	}

	componentWillUnmount() {
		const { image } = this;
		// reset handlers, otherwise get triggered again once image is unmounted
		image.onload = null;
		image.onerror = null;
	}

	render() {
		let { isLoading, isEditing, error, thumbnailUrl } = this.state;
		const { node, actionHandler, aclAllow } = this.props;
		const { nodeHandler } = actionHandler;
		const isDeleting = nodeHandler.isDeleting && nodeHandler.currentNode.$id === node.$id;
		const { properties } = node;

		const { title } = properties;

		const subtitle = `${fileSize(node.storage.totalSize)}`;

		const menuItems = () => [
			<ACL allow={aclAllow.edit} key="admin">
				<ListItem
					primaryText="Löschen"
					leftIcon={<FontIcon>delete</FontIcon>}
					onClick={this.handleMenuDelete}
				/>
			</ACL>
		];

		const renderMenu = () => (
			<ACL allow={aclAllow.edit}>
				<div className="card-button-container">
					{ !isEditing && <Button icon onClick={this.handleMenuEdit}>edit</Button> }
					<MenuButton
						key="menu"
						id={`vert-menu${node.$id}`}
						icon
						menuItems={menuItems()}
						simplifiedMenu={false}
						anchor={{
							x: MenuButton.HorizontalAnchors.LEFT,
							y: MenuButton.VerticalAnchors.OVERLAP,
						}}
					>
						<FontIcon>more_vert</FontIcon>
					</MenuButton>
				</div>
			</ACL>
		);

		const renderTitle = () => (
			<div>
				{ isEditing && <TextFieldEdit
					id="title-field-image"
					type="title"
					label="Titel"
					value={title}
					onSubmit={value => this.updateProperty({ title: value })}
					rightIcon={<FontIcon className="icon-done" onClick={this.handleMenuEditExit}>done</FontIcon>}
				/> }
				{ !isEditing && title && <span className="link" onClick={this.handleMenuOpen}>{title}</span> }
			</div>
		);

		const renderSubtitle = () => (
			<span className="link" onClick={this.handleMenuOpen}>{subtitle}</span>
		);

		const renderContent = () => (
			<div className="image-card-item" id={node.$id}>
				<div className="image-card-picture">
					{ isLoading && <Skeleton height={150} /> }
					{	error && <ImagePlaceholder icon={"panorama"} title={error.message} /> }
					{ !isLoading && !error && <img alt="" src={thumbnailUrl} id={`node:${node.$id}:image:${title}`} onClick={this.handleMenuOpen} /> }
				</div>
				<ListItem
					ref={c => this.listItem = c}
					primaryText={renderTitle()}
					secondaryText={renderSubtitle()}
					rightIcon={renderMenu()}
					disabled

				/>
			</div>
		);

		const renderIsDeleting = () => <LoadingSpinnerSmall message="Bild wird gelöscht..." />;

		return (
			<div className="image-card-item-container">
				{!isDeleting ? renderContent() : renderIsDeleting()}
				<Divider className="image-card-item-divider"/>
			</div>
		)
	}
}

export default ImageCardItem;


// WEBPACK FOOTER //
// ./src/components/cards/image/v1/ImageCardItem.jsx